import SelectController from 'controllers/select-controller';
import { useFormContext } from 'react-hook-form';
import { ICommonSelectValues } from 'utils/types';
import { VariantLibrayForm } from '../../types';
import { Grid } from '@mui/material';

interface IVariantLibrarySelect {
  options: ICommonSelectValues[];
}

export const VariantLibrarySelect = ({ options }: IVariantLibrarySelect) => {
  const form = useFormContext<VariantLibrayForm>();

  const onSelectChange = (e) => {
    const name = options.find((option) => option.value === e.target.value)?.label;
    form.setValue('name', name);
  };

  const renderValue = () => {
    const name = form.watch('name');

    return name || 'Select Variant Type';
  };

  return (
    <Grid sx={{ marginBottom: '22px' }}>
      <SelectController
        fullWidth
        isSelect
        withError
        name="id"
        label="Variant Type"
        options={options}
        renderValue={renderValue}
        onChange={onSelectChange}
      />
    </Grid>
  );
};
